import { render, staticRenderFns } from "./ReportCreate.vue?vue&type=template&id=5b0b33ec&scoped=true&"
import script from "./ReportCreate.vue?vue&type=script&lang=js&"
export * from "./ReportCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0b33ec",
  null
  
)

export default component.exports